import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';

import locale from 'antd/es/date-picker/locale/fr_FR';

import { Form, TimePicker, Col } from 'antd';

function TimeField({
  data,
  index,
  // default
  className
}) {
  const childClassNames = classNames('custom-form-column', 'time-input-column', className);

  const format = 'HH:mm';
  const now = moment();

  return data && (
    <Col
      key={data?.name + index + '-col'}
      md={data?.col || 24}
      xs={24}
      offset={data?.offset || null}
      className={childClassNames}
    >
      <Form.Item
        key={data?.name + index + '-item'}
        label={data?.displayLabel ? data?.label : data?.label}
        name={data?.name}
        className={data?.name + '-wrapper'}
        initialValue={
          data?.value ? moment(data?.value, format) : moment(now, format)
        }
        rules={[
          {
            required: data?.required || false,
            message: `Veuillez sélectionner l'heure`,
          },
        ]}
      >
        <TimePicker
          format={format}
          locale={{
            ...locale,
            lang: {
              ...locale.lang,
              now: 'À présent',
              ok: 'Ok',
            },
          }}
        />
      </Form.Item>
    </Col>
  );
};

TimeField.defaultProps = {
  index: 1,
};

TimeField.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.object.isRequired,
  ]),
};

export default memo(TimeField);